import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'adp',
});

export const awsNativeOrderRef = createSubRouteRef({
  id: 'adp.awsNativeOrder',
  parent: rootRouteRef,
  path: '/order/aws-native',
});

export const databricksOrderRef = createSubRouteRef({
  id: 'adp.databricksOrder',
  parent: rootRouteRef,
  path: '/order/databricks',
});

export const orderReceivedRef = createSubRouteRef({
  id: 'adp.orderReceived',
  parent: rootRouteRef,
  path: '/order/received',
});

export const orderStatusRef = createSubRouteRef({
  id: 'adp.orderStatus',
  parent: rootRouteRef,
  path: '/order/status/:orderId',
});

export const orderConfirmRef = createSubRouteRef({
  id: 'adp.orderConfirm',
  parent: rootRouteRef,
  path: '/order/confirm/:orderId',
});
